import httpClient from "./httpClient";

export const authApi = {
  login: (email, password) =>
    httpClient.post("/auth/login", { email, password }, { skipAuth: true, maxRetries: 0 }),

  // Called once on app load to silently restore a session from the
  // httpOnly refresh cookie, if the browser still has one.
  refresh: () => httpClient.post("/auth/refresh", {}, { skipAuth: true, maxRetries: 0 }),

  logout: () => httpClient.post("/auth/logout", {}, { maxRetries: 0 }),

  me: () => httpClient.get("/auth/me", { maxRetries: 0 }),
};

export const userApi = {
  list: () => httpClient.get("/users"),
  create: (payload) => httpClient.post("/users", payload, { maxRetries: 0 }),
  update: (id, payload) => httpClient.patch(`/users/${id}`, payload, { maxRetries: 0 }),
  remove: (id) => httpClient.delete(`/users/${id}`, { maxRetries: 0 }),
};
